import React, { useEffect } from 'react'

import { Link } from 'react-router-dom'

import PrivateRoute from '../../../components/PrivateRoute'
import ProfileSidebar from '../../../components/ProfileSidebar'

import {
  Box,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  ListItem,
  ListItemIcon,
  List,
  Typography,
  Divider,
  ListItemText,
  ListItemButton,
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux'
import { getProfile } from '../../../actions/userActions'
import LaunchIcon from '@mui/icons-material/Launch'

const Playlists = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const matches = useMediaQuery(theme.breakpoints.up('md'))
  const { profile } = useSelector(state => state.userState)

  useEffect(() => {
    dispatch(getProfile())
  }, [])

  return (
    <PrivateRoute>
      <Box sx={{ display: 'flex' }}>
        <ProfileSidebar page={2} />
        <Card sx={{ width: 1200, mt: 5, height: 'fit-content', mx: matches ? 'auto' : 0, p: 1 }}>
          <CardContent>
            <Typography sx={{ mb: 3 }} variant='h6'>Your playlists</Typography>
            <Divider />
            {profile && profile.playlists.length > 0 ? <List>
              {profile.playlists.map(playlist => (
                <Link key={playlist._id} style={{ textDecoration: 'none', color: 'inherit' }} to={`/playlists/${playlist._id}`}>
                  <ListItemButton key={playlist._id}>
                    <ListItem sx={{ width: '100%' }} disablePadding>
                      <ListItemText secondary={playlist.isPublic ? 'Public' : 'Private'}><Typography variant='body1'>{playlist.title}</Typography></ListItemText>
                      <ListItemIcon>
                        <LaunchIcon />
                      </ListItemIcon>
                    </ListItem>
                  </ListItemButton>
                </Link>
              ))}
            </List> : <>
              <Typography color='textSecondary' sx={{ mt: 2 }}>You have no playlists yet. Click <Link style={{ color: '#1366f2' }} to='/add-playlist'>here</Link> to create your first playlist.</Typography>
            </>}
          </CardContent>
        </Card>
      </Box>
    </PrivateRoute>
  )
}

export default Playlists